import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Loader from '../Loader';
import { get, post, put, deleteM } from "../../utility/Adapter";
import { withParams } from "../HOC";
import axios from 'axios';
import Parser from 'html-react-parser';

const CandidateProfile = (props) => {
    const [loading, setLoading] = useState(false);
    const [percentage, setPercentage] = useState('0%');
    const [saveBtn, setSaveBtn] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [myProfile, setMyProfile] = useState({});
    const [countries, setCountries] = useState([]);
    const [nationality, setNationality] = useState([]);
    const [speaking, setSpeaking] = useState([]);
    const [hobbies, setHobbies] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [languageSkills, setLanguageSkills] = useState([]);
    const [candidateStatus, setCandidateStatus] = useState(0);
    const [step, setStep] = useState("0");
    const [candidateId, setCandidateId] = useState(null);
    const [image, setImage] = useState(null);
    const [candidateResume, setCandidateResume] = useState(null);
    const [schoolsDiv, setSchoolsDiv] = useState(null);
    const [schoolsArr, setSchoolsArr] = useState([]);
    const [candidateSchools, setCandidateSchools] = useState([]);
    const [candidateCollege, setCandidateCollege] = useState([]);

    const [courseDiv, setCourseDiv] = useState(null);
    const [courseArr, setCourseArr] = useState([]);
    const [affliators, setAffliators] = useState([]);
    const [note, setNote] = useState('');
    const [selectedAffiliator, setSelectedAffiliator] = useState('');
    const [affiliateStatus, setAffiliateStatus] = useState('');
    const [affiliatorNote, setAffiliatorNote] = useState('');

    useEffect(() => {
        setLoading(true);
        Promise.all([
            get('staff/candidate/profile/' + props.params.id),
            get('staff/affiliators'),
            get('staff/departments/en')
        ]).then(([profileRes, affiliatesRes, departmentsRes]) => {
            const profileData = profileRes.data;
            const affiliatesData = affiliatesRes.data;
            const departmentsData = departmentsRes.data;

            setMyProfile(profileData);
            setAffliators(affiliatesData);
            setDepartments(departmentsData);

            setCandidateStatus(profileData.candidate_status);
            setStep(profileData.candidate_step);
            setCandidateId(profileData.candidate_id);
            setCandidateResume(profileData.candidate_resume);
            setCandidateSchools(profileData.candidate_schools);

            if (profileData.candidate_colleges) {
                setCandidateCollege(profileData.candidate_colleges);
            }

            if (profileData.candidate_image) {
                let candidateImage = profileData.candidate_image;
                if (!candidateImage.includes('.')) {
                    candidateImage += '.png';
                }
                setImage(`${process.env.REACT_APP_BASE_URL}candidates/images/${candidateImage}`);
            }

            if (profileData.candidate_note) {
                setNote(profileData.candidate_note);
            } else if (profileData.candidate_notes) {
                setNote(profileData.candidate_notes);
            } else if (profileData.candidate_additional_note) {
                setNote(profileData.candidate_additional_note);
            }

            if (profileData.affiliator_id) {
                setSelectedAffiliator(profileData.affiliator_id);
            }

            if (profileData.candidate_affiliator_status) {
                setAffiliateStatus(profileData.candidate_affiliator_status);
            }

            if (profileData.candidate_affiliator_note) {
                setAffiliatorNote(profileData.candidate_affiliator_note);
            }

            setLoading(false);
        }).catch(error => {
            console.error("Error loading initial data:", error);
            setLoading(false);
        });
    }, [props.params.id]);

    const _changeStatus = () => {
        var affiliate_status = affiliateStatus;
        var affiliator_note = affiliatorNote;
        var affiliator = selectedAffiliator;

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "affiliate_status": affiliate_status,
            "affiliator_note": affiliator_note,
            "affiliator": affiliator
        });

        setLoading(true);
        post('staff/candidates/change_affiliate_status', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });
    }

    const uploadFile = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('candidateId', props.params.id);
        setImage(URL.createObjectURL(e.target.files[0]));
        setLoading(true);

        const headers = {
            "Contetnt-Type": "multipart/form-data",
        }

        axios.post(process.env.REACT_APP_BASE_URL + 'candidates/avatar_upload', formData, {
            headers: headers
        })
            .then((res) => {
                setLoading(false);
                alert("Successfully Uploaded!");
            })
            .catch((error) => {
                setLoading(false);
                alert('Avatar upload failed, Please try agian')
            })
    }

    const _addNote = () => {
        if (note.length === 0) {
            alert("Please enter note");
            return false;
        }

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "note": note
        });

        setLoading(true);
        post('staff/candidates/note', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });
    }

    const _changeCandidateStatus = (cstatus) => {
        setCandidateStatus(cstatus);

        var raw = JSON.stringify({
            "candidate_id": props.params.id,
            "candidate_status": cstatus,
        });

        setLoading(true);
        post('staff/candidates/change_candidate_status', raw).then(async function (response) {
            setLoading(false);
            alert("Successfully updated");
        }).catch(function (error) {
            setLoading(false);
        });
    }

    return (
        <>
            <Header />
            <Loader loading={loading} />
            <main>
                <div className="container">
                    <div className="page-title-container">
                        <div className="row">
                            <div className="col-12 col-md-7">
                                <span className="align-middle text-muted d-inline-block lh-1 pb-2 pt-2 text-small"></span>
                                <h1 className="mb-0 pb-0 display-4 text-capitalize" id="title"></h1>
                            </div>
                        </div>
                    </div>
                    {Object.keys(myProfile).length > 0 && (
                        <div className='row'>
                            <div className='col-xl-12'>
                                <div className='row'>
                                    <div className="col-3 col-sm-3 col-lg-3 text-center">
                                        <label htmlFor="uploadDoc"><img className="img-fluid rounded-md" src={image} style={{ width: 150, height: 150 }} alt="Candidate" /></label>
                                        <input className="d-none" accept="image/*" type="file" name="file_source" size="40" onChange={(e) => uploadFile(e)} id="uploadDoc" />
                                        <br /><a download href={image} className='mt-1'>Download</a>
                                    </div>
                                    <div className='col-sm-3'>
                                        <h3 className="alert-heading" style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>{myProfile.candidate_first_name} {myProfile.candidate_last_name}</h3>
                                        <span>{myProfile.candidate_email}</span><br /><span>{myProfile.candidate_phone}</span>
                                    </div>
                                    <div className="col-12 col-sm-6 col-lg-3">
                                        <div className="mb-5">
                                            <div>
                                                <div className="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                                    <span>Language Level</span>
                                                </div>
                                                <div className="text-small text-muted mb-1"></div>
                                                <div className="cta-1 text-primary">
                                                    {myProfile.candidate_current_language_level === 'NOT_ENROLLED' ? 'Not yet enrolled' :
                                                     myProfile.candidate_current_language_level === 'A1_ENROLLED' ? 'A1 Enrolled' :
                                                     myProfile.candidate_current_language_level === 'A1_COMPLETE' ? 'A1 Complete' :
                                                     myProfile.candidate_current_language_level === 'B1_COMPLETE' ? 'B1 Complete' :
                                                     myProfile.candidate_current_language_level === 'B2_COMPLETE' ? 'B2 Complete' :
                                                     myProfile.candidate_current_language_level === 'C1_COMPLETE' ? 'C1 Complete' :
                                                     myProfile.candidate_current_language_level === 'C2_COMPLETE' ? 'C2 Complete' : 'N/A'}
                                                </div>
                                            </div>
                                            <div className="mb-5">
                                                <div>
                                                    <div className="heading mb-0 d-flex justify-content-between lh-1-25 mb-3 pt-5">
                                                        <span>KDA Brochure Status</span>
                                                    </div>
                                                    <div className="text-small text-muted mb-1"></div>
                                                    <div className="cta-1 text-primary">
                                                        {myProfile.has_read_information_brochure_2024 ? "Read" : "Not Read"} ({myProfile.has_read_information_brochure_2024_time ? new Date(myProfile.has_read_information_brochure_2024_time).toLocaleDateString('en-GB') : "N/A"})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-lg-3">
                                        <div className="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                            <span>Agreement Status</span>
                                        </div>
                                        <div className="text-small text-muted mb-1"></div>
                                        <div className="cta-1 text-primary">
                                            {myProfile.agreement_status === 1 ? "Signed" : "Not Signed"}
                                        </div>
                                        <div className="mb-5"></div>
                                        <div className="heading mb-0 d-flex justify-content-between lh-1-25 mb-3">
                                            <span>Agreement Date</span>
                                        </div>
                                        <div className="text-small text-muted mb-1"></div>
                                        <div className="cta-1 text-primary">
                                            {myProfile.agreement_date ? new Date(myProfile.agreement_date).toLocaleDateString('en-GB') : "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-12'>
                                        <div className='card mt-5'>
                                            <div className='card-body'>
                                                <h4>Candidate Status</h4>
                                                <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="not_started" value="1" checked={candidateStatus == 1} onChange={() => _changeCandidateStatus('1')} />
                                                        <label className="form-check-label" htmlFor="not_started">Not Started</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="in_progress" value="2" checked={candidateStatus == 2} onChange={() => _changeCandidateStatus('2')} />
                                                        <label className="form-check-label" htmlFor="in_progress">In Progress</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="completed" value="3" checked={candidateStatus == 3} onChange={() => _changeCandidateStatus('3')} />
                                                        <label className="form-check-label" htmlFor="completed">Completed</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className='card mt-5'>
                                        <div className='card-body'>
                                            <div className="col-sm-12">
                                                <label>Affiliator</label>
                                                <select className='form-control' id="affiliator" value={selectedAffiliator} onChange={(e) => setSelectedAffiliator(e.target.value)}>
                                                    <option value=''>Select Affiliator</option>
                                                    {
                                                        affliators.map((a, k) =>
                                                            <option value={a._id} data-id={a.affiliator_id} key={k}>{a.affiliator_name} [ {a.affiliator_id} ]</option>
                                                        )
                                                    }
                                                </select>
                                            </div>

                                            <div className="col-sm-12">
                                                <label>Change status for affiliates</label>
                                                <select className='form-control' id="affiliate_status" value={affiliateStatus} onChange={(e) => setAffiliateStatus(e.target.value)}>
                                                    <option value='under review'>Under Review</option>
                                                    <option value='in progress'>In Progress</option>
                                                    <option value='interview completed'>Interview Completed</option>
                                                    <option value='candidate joined'>Candidate Joined</option>
                                                    <option value='get paid'>Get Paid</option>
                                                    <option value='rejected'>Rejected</option>
                                                </select>
                                            </div>

                                            <div className="col-sm-12">
                                                <label>Notes</label>
                                                <input type='text' className='form-control' name='affiliator_note' id='affiliator_note' value={affiliatorNote} onChange={(e) => setAffiliatorNote(e.target.value)} />
                                            </div>
                                            <div className='col-2 top-label'>
                                                <button class="btn btn-primary" type="button" onClick={() => _changeStatus()} style={{ marginTop: 22 }}>Update</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1 mt-5">
                                
                                <div className='card'>
                                    <div className='card-body'>
                                        <h2 className="small-title" style={{ margin: 0 }}>Note</h2>
                                            <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-1">
                                                <div className='card mb-5'>
                                                    <div className='card-body p-0'>
                                                        <textarea className='form-control' id="note" style={{ height: 100 }} value={note} onChange={(e) => setNote(e.target.value)}></textarea><br />
                                                        <button className="btn btn-primary" type="button" onClick={() => _addNote()}>Add Note</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </>
    );
}

export default withParams(CandidateProfile);